import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cynosure',
  templateUrl: './cynosure.component.html',
  styleUrls: ['./cynosure.component.scss']
})
export class CynosureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
